<app-fullscreen-overlay
  [isOverlayLoading]="isOverlayLoading"
></app-fullscreen-overlay>

<div *ngIf="!isLoading" class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div
      id="kt_app_content_container"
      class="app-container container-fluid org-detail-page-container"
    >
      <form [formGroup]="orgForm" (ngSubmit)="onSubmit()" class="row g-5">
        <div class="col-xl-6">
          <div class="card card-flush h-lg-100">
            <div class="card-header pt-7">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label fw-bold text-white">
                  <i class="fa-solid fa-layer-group text-orange me-2"></i>
                  {{ "organization.organizationInfo" | translate }}
                </span>
                <span class="text-gray-500 mt-1 fw-semibold fs-7">{{
                  "organization.updateDetailsDescription" | translate
                }}</span>
              </h3>
              <div class="card-toolbar">
                <button
                  type="submit"
                  class="btn btn-sm btn-primary"
                  [disabled]="isSaving"
                >
                  {{ "save" | translate }}
                </button>
              </div>
            </div>

            <div class="card-body">
              <div
                class="avatar-upload-box d-flex align-items-center p-5 mb-10 cursor-pointer"
                (click)="avatarFileInput.click()"
              >
                <input
                  #avatarFileInput
                  type="file"
                  class="d-none"
                  accept="image/*"
                  (change)="onAvatarSelected($event)"
                />
                <div class="avatar-circle me-5">
                  <img
                    *ngIf="organizationAvatar"
                    [src]="organizationAvatar"
                    alt="organization-avatar"
                    class="w-100 h-100 rounded-circle object-fit-cover"
                  />
                  <div *ngIf="!organizationAvatar">
                    {{
                      orgForm.get("name")?.value?.charAt(0)?.toUpperCase() ||
                        "L"
                    }}
                  </div>
                </div>
                <div>
                  <div class="fw-bold text-orange mb-1">
                    {{ "organization.clickToUpload" | translate }}
                    <span class="text-gray-500 fw-normal">{{
                      "organization.orDragAndDrop" | translate
                    }}</span>
                  </div>
                  <div class="text-gray-500 fs-7">
                    {{ "organization.uploadFileTypes" | translate }}
                  </div>
                </div>
              </div>

              <div class="row mb-6">
                <div class="col-12 mb-6">
                  <label class="form-label required">{{
                    "name" | translate
                  }}</label>
                  <input
                    formControlName="name"
                    type="text"
                    class="form-control bg-input-fixed mb-2"
                    [placeholder]="'organization.organizationName' | translate"
                  />
                  <div
                    *ngIf="isControlInvalid('name')"
                    class="text-danger fs-7"
                  >
                    {{ "organization.required" | translate }}
                  </div>
                </div>

                <div class="col-12 mb-6">
                  <label class="form-label required">{{
                    "email" | translate
                  }}</label>
                  <input
                    formControlName="email"
                    type="email"
                    class="form-control bg-input-fixed mb-2"
                    [placeholder]="'email' | translate"
                  />
                  <div
                    *ngIf="isControlInvalid('email')"
                    class="text-danger fs-7"
                  >
                    {{ "organization.invalidEmail" | translate }}
                  </div>
                </div>

                <div class="row gx-5 mb-6 align-items-start">
                  <div class="col-md-4">
                    <label class="form-label required">{{
                      "phoneNumber" | translate
                    }}</label>
                    <div class="w-100">
                      <ngx-intl-tel-input
                        appPhoneInput
                        [cssClass]="'form-control'"
                        [enableAutoCountrySelect]="true"
                        [enablePlaceholder]="true"
                        [searchCountryFlag]="true"
                        [searchCountryField]="[
                          SearchCountryField.Iso2,
                          SearchCountryField.Name,
                        ]"
                        [selectFirstCountry]="false"
                        [selectedCountryISO]="defaultOrgCountry"
                        [maxLength]="15"
                        [phoneValidation]="true"
                        [separateDialCode]="true"
                        name="phoneNumber"
                        formControlName="phone"
                      >
                      </ngx-intl-tel-input>
                    </div>
                    <div
                      *ngIf="isControlInvalid('phone')"
                      class="text-danger fs-7 mt-1"
                    >
                      <div *ngIf="orgForm.get('phone')?.errors?.['required']">
                        {{ "phoneNumberIsRequired" | translate }}
                      </div>
                      <div
                        *ngIf="
                          orgForm.get('phone')?.errors?.['validatePhoneNumber']
                        "
                      >
                        {{ "phoneNumberIsNotValid" | translate }}
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label class="form-label required">{{
                      "customerCode" | translate
                    }}</label>
                    <input
                      formControlName="customerCode"
                      type="text"
                      class="form-control bg-input-fixed"
                      [placeholder]="'customerCode' | translate"
                    />
                    <div
                      *ngIf="isControlInvalid('customerCode')"
                      class="text-danger fs-7 mt-1"
                    >
                      {{ "organization.required" | translate }}
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label class="form-label required">{{
                      "organization.timeZone" | translate
                    }}</label>
                    <!-- <select
                      formControlName="timeZone"
                      class="form-select bg-input-fixed w-100"
                    >
                      <option value="">
                        {{ "organization.selectTimeZone" | translate }}
                      </option>
                      <option *ngFor="let tz of timeZones" [value]="tz.name">
                        {{ tz.label }}
                      </option>
                    </select> -->
                    <app-select
                      formControlName="timeZone"
                      [items]="timeZones"
                      bindLabel="label"
                      bindValue="name"
                      [clearable]="true"
                      [multiple]="false"
                      [placeholder]="'organization.timeZone' | translate"
                    ></app-select>
                    <div
                      *ngIf="isControlInvalid('timeZone')"
                      class="text-danger fs-7 mt-1"
                    >
                      {{ "organization.required" | translate }}
                    </div>
                  </div>
                </div>

                <div class="row mb-6">
                  <div class="col-12">
                    <div
                      class="d-flex flex-stack assessment-toggle-container rounded border border-dashed border-gray-700"
                    >
                      <div class="me-5">
                        <label class="fs-6 fw-bold text-white">{{
                          "organization.enableAssessment" | translate
                        }}</label>
                        <div class="fs-7 text-gray-500">
                          {{ "organization.assessmentDescription" | translate }}
                        </div>
                      </div>
                      <div
                        class="form-check form-switch form-check-custom form-check-solid"
                      >
                        <input
                          class="form-check-input h-25px w-45px"
                          type="checkbox"
                          formControlName="isAssessmentActive"
                          id="assessmentSwitch"
                        />
                        <label
                          class="form-check-label fw-semibold text-gray-400"
                          for="assessmentSwitch"
                        >
                          {{
                            (orgForm.get("isAssessmentActive")?.value
                              ? "yes"
                              : "no"
                            ) | translate
                          }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 mb-6">
                  <label class="form-label">{{
                    "organization.address" | translate
                  }}</label>
                  <textarea
                    formControlName="address"
                    class="form-control bg-list-card"
                    rows="2"
                    [placeholder]="'organization.address' | translate"
                  ></textarea>
                </div>

                <div class="col-12">
                  <label class="form-label">{{
                    "organization.contactPerson" | translate
                  }}</label>
                  <input
                    formControlName="contactPerson"
                    type="text"
                    class="form-control bg-input-fixed"
                    [placeholder]="'organization.contactPerson' | translate"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6">
          <div class="card card-flush h-auto min-h-300px">
            <div class="card-header pt-7">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label fw-bold text-white"
                  ><i class="fa-solid fa-building text-white me-2"></i
                  >{{ "organization.facilities" | translate }}</span
                >
              </h3>
              <div class="card-toolbar">
                <button
                  #openFacilityModalBtn
                  type="button"
                  class="d-none"
                  data-bs-toggle="modal"
                  data-bs-target="#kt_modal_facility"
                ></button>
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  (click)="openFacilityModal()"
                >
                  <i class="fa-solid fa-plus text-orange"></i
                  >{{ "organization.addFacility" | translate }}
                </button>
              </div>
            </div>
            <div class="card-body pt-5">
              <div formArrayName="facilities" class="d-flex flex-column gap-3">
                <div
                  *ngIf="facilitiesFormArray.length === 0"
                  class="d-flex flex-column align-items-center justify-content-center text-gray-500 border border-dashed border-gray-700 rounded py-10 px-5"
                >
                  <i
                    class="fa-solid fa-building-circle-slash fs-1 text-gray-600 mb-3"
                  ></i>
                  <div class="fs-7 fw-semibold">
                    {{ "organization.noFacilitiesFound" | translate }}
                  </div>
                </div>

                <div
                  *ngFor="
                    let facility of facilitiesFormArray.controls;
                    let i = index
                  "
                  [formGroupName]="i"
                  class="d-flex align-items-center bg-list-card border border-gray-800 rounded p-4 hover-elevate-up transition-300"
                >
                  <div class="symbol symbol-40px me-4">
                    <div class="symbol-label bg-light-orange text-orange">
                      <i class="fa-solid fa-building fs-5"></i>
                    </div>
                  </div>
                  <div
                    class="d-flex flex-column flex-grow-1 cursor-pointer overflow-hidden"
                    (click)="editFacility(i)"
                  >
                    <span class="fw-bold text-white fs-6 mb-1">{{
                      facility.get("name")?.value
                    }}</span>
                    <div class="d-flex text-gray-500 fs-7">
                      <span class="me-3" *ngIf="facility.get('email')?.value"
                        ><i class="fa-solid fa-envelope me-1 fs-9"></i>
                        {{ facility.get("email")?.value }}</span
                      >
                      <span *ngIf="facility.get('address')?.value"
                        ><i class="fa-solid fa-location-dot me-1 fs-9"></i>
                        {{ facility.get("address")?.value }}</span
                      >
                    </div>
                  </div>
                  <div class="d-flex align-items-center ms-4">
                    <button
                      type="button"
                      class="btn btn-icon btn-sm btn-active-color-primary w-30px h-30px bg-body me-2"
                      (click)="editFacility(i)"
                      [title]="'edit' | translate"
                    >
                      <i class="fa-solid fa-pen fs-8"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-icon btn-sm btn-active-color-danger w-30px h-30px bg-body"
                      (click)="promptDeleteFacility(i)"
                      [title]="'delete' | translate"
                    >
                      <i class="fa-solid fa-trash fs-7"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="kt_modal_facility" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2">
          {{
            (editingFacilityIndex !== null
              ? "organization.editFacility"
              : "organization.addFacility"
            ) | translate
          }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="tempFacilityForm">
          <div class="mb-3">
            <label class="form-label required">{{ "name" | translate }}</label>
            <input
              type="text"
              class="form-control bg-input-fixed"
              formControlName="name"
              [placeholder]="'organization.facilityName' | translate"
            />
            <div
              *ngIf="isModalControlInvalid('name')"
              class="text-danger fs-7 mt-1"
            >
              {{ "validation.required" | translate }}
            </div>
          </div>

          <div class="row mb-3 gx-5">
            <div class="col-md-6">
              <label class="form-label required">{{
                "phoneNumber" | translate
              }}</label>
              <ngx-intl-tel-input
                appPhoneInput
                [cssClass]="'form-control'"
                [enableAutoCountrySelect]="true"
                [enablePlaceholder]="true"
                [searchCountryFlag]="true"
                [searchCountryField]="[
                  SearchCountryField.Iso2,
                  SearchCountryField.Name,
                ]"
                [selectFirstCountry]="false"
                [selectedCountryISO]="defaultFacilityCountry"
                [maxLength]="15"
                [phoneValidation]="true"
                [separateDialCode]="true"
                name="facilityPhone"
                formControlName="phone"
              >
              </ngx-intl-tel-input>
              <div
                *ngIf="isModalControlInvalid('phone')"
                class="text-danger fs-7 mt-1"
              >
                {{ "phoneNumberIsRequired" | translate }}
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label required">{{
                "organization.timeZone" | translate
              }}</label>
              <app-select
                formControlName="timeZone"
                [items]="timeZones"
                bindLabel="label"
                bindValue="name"
                [clearable]="true"
                [multiple]="false"
                [placeholder]="'organization.timeZone' | translate"
              ></app-select>
              <div
                *ngIf="isModalControlInvalid('timeZone')"
                class="text-danger fs-7 mt-1"
              >
                {{ "validation.required" | translate }}
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label required">{{
              "organization.contactPerson" | translate
            }}</label
            ><input
              type="text"
              class="form-control bg-input-fixed"
              formControlName="contactPerson"
              [placeholder]="'organization.contactPerson' | translate"
            />
            <div
              *ngIf="isModalControlInvalid('contactPerson')"
              class="text-danger fs-7 mt-1"
            >
              {{ "validation.required" | translate }}
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label required">{{ "email" | translate }}</label
            ><input
              type="email"
              class="form-control bg-input-fixed"
              formControlName="email"
              [placeholder]="'email' | translate"
            />
            <div
              *ngIf="isModalControlInvalid('email')"
              class="text-danger fs-7 mt-1"
            >
              <div *ngIf="tempFacilityForm.get('email')?.errors?.['required']">
                {{ "validation.required" | translate }}
              </div>
              <div *ngIf="tempFacilityForm.get('email')?.errors?.['email']">
                {{ "organization.invalidEmail" | translate }}
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label required">{{
              "organization.address" | translate
            }}</label>
            <textarea
              class="form-control bg-list-card"
              rows="2"
              formControlName="address"
              [placeholder]="'organization.address' | translate"
            ></textarea>
            <div
              *ngIf="isModalControlInvalid('address')"
              class="text-danger fs-7 mt-1"
            >
              {{ "validation.required" | translate }}
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          #closeFacilityModalBtn
          type="button"
          class="d-none"
          data-bs-dismiss="modal"
        ></button>
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "cancel" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary cursor-pointer"
          (click)="saveFacilityFromModal()"
          [disabled]="tempFacilityForm.invalid"
        >
          {{ "save" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<button
  #openDeleteFacilityModalBtn
  type="button"
  class="d-none"
  data-bs-toggle="modal"
  data-bs-target="#kt_modal_delete_facility"
></button>
<div
  class="modal fade"
  id="kt_modal_delete_facility"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2">
          {{ "organization.deleteFacility" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4">
        {{ "organization.deleteFacilityConfirmation" | translate }}
      </div>
      <div class="modal-footer">
        <button
          #closeDeleteFacilityModalBtn
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "cancel" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-danger cursor-pointer"
          (click)="confirmDeleteFacility()"
        >
          {{ "delete" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
